import React from "react";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { trpcClient } from "@/lib/trpc";
import { QCProcessForm, type QCProcessFormPrefill } from "./QCProcessForm";
import StandardDetailLayout from "@/layouts/StandardDetailLayout";
import type { QCProcessFormValues } from "@/lib/schemas/qc";

export default function QCProcessCreate() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  // Read prefill Search Params (Rule 8 Link-To-Form & Prefill)
  const searchParams = useSearch({ strict: false }) as Record<string, string>;
  const prefill: QCProcessFormPrefill = {
    productionOrderId: searchParams?.productionOrderId || "",
    routingStepId: searchParams?.routingStepId || "",
    machineId: searchParams?.machineId || "",
    processStep: searchParams?.processStep || "",
    checkType: (searchParams?.checkType as any) || "FIRST_PIECE",
  };

  const handleSubmit = async (data: QCProcessFormValues) => {
    try {
      const created = await (trpcClient as any).qcProcess.create.mutate(data);
      toast.success("Lập biên bản kiểm tra công đoạn (IPQC) thành công!");
      await queryClient.invalidateQueries({ queryKey: ["qcProcess"] });
      await queryClient.invalidateQueries({ queryKey: ["qc-process-all"] });
      await queryClient.invalidateQueries({ queryKey: ["po-ipqc-list"] });
      
      // Rule 3.3 Anti-Form Trap: replace = true
      navigate({
        to: "/qc-process/$checkId",
        params: { checkId: created.id },
        replace: true,
      });
    } catch (err: any) {
      toast.error(err?.message || "Lỗi khi lập biên bản IPQC");
      throw err;
    }
  };

  return (
    <StandardDetailLayout
      breadcrumbs={[
        { label: "QC Công đoạn", to: "/qc-process" },
        { label: "Nghiệm thu mới (IPQC)" },
      ]}
      title="Lập Biên Bản IPQC"
      onBack={() => navigate({ to: "/qc-process" })}
      showContextPanel={false}
    >
      <div className="bg-white rounded-xl border border-slate-200 p-6 shadow-xs">
        <QCProcessForm
          onSubmit={handleSubmit}
          onCancel={() => navigate({ to: "/qc-process" })}
          prefill={prefill}
          isDrawerMode={false}
        />
      </div>
    </StandardDetailLayout>
  );
}
